import React, { useState, useEffect } from "react";
import SideBar from "./SideBar";
import ChatsTab from "./ChatsTab";
import axios from "axios";
import localforage from "localforage";
import { useNavigate } from "react-router-dom";
import usePushNotifications from "../hooks/usePushNotifications";

const API_URL = process.env.REACT_APP_API_URL;

const ChatPage = () => {
  const [currentUserEmail, setCurrentUserEmail] = useState("");
  const [allEmployees, setAllEmployees]         = useState([]);
  const navigate = useNavigate();

  // ── Register push notifications for this user ─────────────────────────────
  usePushNotifications(currentUserEmail);

  useEffect(() => {
    const init = async () => {
      const email = await localforage.getItem("email");
      if (email) setCurrentUserEmail(email.toLowerCase());

      try {
        const tok = await localforage.getItem("token");
        if (!tok) return;
        const res = await axios.get(`${API_URL}/employeedata/all-emails`, {
          headers: { Authorization: `Bearer ${tok}` },
        });
        setAllEmployees(res.data?.emails || []);
      } catch (err) {
        console.warn("Could not load employee list:", err.message);
      }
    };
    init();
  }, []);

  return (
    <>
      <SideBar />
      <div className="dashboard-container" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <ChatsTab
          currentUserEmail={currentUserEmail}
          allEmployees={allEmployees}
          onViewTask={() => navigate("/workspace")}
        />
      </div>
    </>
  );
};

export default ChatPage;